import React from "react";
import PropTypes from "prop-types";
import "./intrRecoveryVisibilityTable.css";

const INTRRecoveryGlobalVisibilityTable = ({ data = [], topNValue = 10 }) => {

  const topNLabel1 = `Order Loss Mitigated Value (Top ${topNValue})`;

  /* ✅ K / L / Cr FORMATTER */
  const formatToCappedUnit = (value) => {
    if (value === null || value === undefined) return "-";
    if (value < 1000) {
      return `${value}`;
    }
    if (value < 100000) {
      return `${(value / 1000).toFixed(1)} K`;
    }

    if (value < 10000000) {
      return `${(value / 100000).toFixed(1)} L`;
    }

    return `${(value / 10000000).toFixed(1)} Cr`;
  };

  /* ✅ NORMAL FORMAT (for counts/qty) */
  const format = (value) =>
    value === null || value === undefined ? "-" : value.toLocaleString();

  return (
    <div className="tableWrapper">
      <table className="visibilityTable">
        <thead>
          <tr>
            <th>Receiving Plant</th>
            <th>Count of GRNs</th>
            <th>Total Count of Cases</th>
            <th>Value of Material</th>
            <th>Total Material Quantity</th>
            <th>{topNLabel1}</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={6} style={{ textAlign: "center", padding: "16px" }}>
                No data available
              </td>
            </tr>
          ) : (
            data.map((row) => (
              <tr key={`intr-vis-row-${row["Receiving Plant"]}-${row["Count of GRNs"]}`}> 
                <td>{row["Receiving Plant"]}</td>

                <td>{format(row["Count of GRNs"])}</td>

                <td title={row["Total Count of Cases"]}>
                  {formatToCappedUnit(row["Total Count of Cases"])}
                </td>

                {/* ✅ Value of Material (formatted) */}
                <td title={row["Value of Material"]}>
                  {formatToCappedUnit(row["Value of Material"])}
                </td>

                <td>{format(row["Total Material Quantity"])}</td>

                {/* ✅ Top N Mitigated Value (formatted) */}
                <td title={row[topNLabel1]}>
                  {formatToCappedUnit(row[topNLabel1])}
                </td>

              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

INTRRecoveryGlobalVisibilityTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  topNValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default INTRRecoveryGlobalVisibilityTable;